import { createFileRoute } from "@tanstack/react-router";
import FaqCategoryPage from "@/site/pages/faq-category";

export const Route = createFileRoute("/faq/$category/")({
  component: FaqCategoryPage,
});
